import { UseQueryOptions, infiniteQueryOptions } from '@tanstack/react-query';

import { SearchProductsResponse, SearchShopProductsParams, searchShopProducts } from '~/apis/search';

export const searchShopProductsInfiniteQueryOptions = (
  request: SearchShopProductsParams,
  { enabled, staleTime }: Pick<UseQueryOptions, 'enabled' | 'staleTime'>,
  token = '',
) => {
  const isServer = typeof globalThis.window === 'undefined';

  const buildRequestHeaders = (token: string) => (token ? { headers: { 'X-BUN-AUTH-TOKEN': token } } : {});

  const buildQueryParams = (pageParam: { page: number; a?: number[] }) => ({
    ...(pageParam.a && { a: pageParam.a }),
    ...request,
    page: pageParam.page,
    filters: request.filters ?? isServer,
  });

  return infiniteQueryOptions({
    queryKey: ['search', 'shop', 'products', 'infinite', { ...request }],
    queryFn: ({ pageParam }) =>
      searchShopProducts(buildQueryParams(pageParam), buildRequestHeaders(token)) as Promise<SearchProductsResponse>,
    initialPageParam: { page: request?.page ?? 0, a: request?.a ?? undefined },
    getNextPageParam: (lastPage, _, lastPageParam) => {
      const nextPage = lastPageParam.page + 1;
      if (lastPage.totalPages === 0 || nextPage === lastPage.totalPages) return;
      return {
        page: nextPage,
        a: (lastPage as SearchProductsResponse & { after: number[] }).after,
      };
    },

    select: ({ pages, pageParams }) => ({
      ...pages[pages.length - 1],
      category: pages[0].category,
      filters: pages[0].filters,
      pages: pages.flatMap(({ data }) => data).filter(Boolean),
      page: pageParams[pages.length - 1].page,
    }),

    placeholderData: (data) => data,
    enabled,
    staleTime: staleTime ?? 3000,
    throwOnError: true,
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
